import { useQuery } from 'react-query';
import { getSellerPageData } from '../services';

export const BASE_KEY = 'get-seller';

/**
 * @typedef UseSellerDataQueryArgs
 * @property {string} username
 * @property {import('../types').Seller | {}} initialData
 */

/**
 * @param {UseSellerDataQueryArgs} props
 * @returns {import('react-query').UseQueryResult<import('../../freelancer_page/types').Seller>}
 */
export const useSellerDataQuery = ({ username, initialData = {} }) => {
    const data = useQuery([BASE_KEY, username], () => getSellerPageData(username), {
        refetchInterval: 0,
        initialData,
        enabled: false,
    });

    return data;
};
